var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNotificationIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2106_5359)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.00065 11.834C8.27679 11.834 8.50065 11.6101 8.50065 11.334V7.33398C8.50065 7.05784 8.27679 6.83398 8.00065 6.83398C7.72451 6.83398 7.50065 7.05784 7.50065 7.33398V11.334C7.50065 11.6101 7.72451 11.834 8.00065 11.834Z",
    fill: "#E12C2C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.00065 4.66732C8.36884 4.66732 8.66732 4.96579 8.66732 5.33398C8.66732 5.70217 8.36884 6.00065 8.00065 6.00065C7.63246 6.00065 7.33398 5.70217 7.33398 5.33398C7.33398 4.96579 7.63246 4.66732 8.00065 4.66732Z",
    fill: "#E12C2C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.833984 8.00065C0.833984 4.04261 4.04261 0.833984 8.00065 0.833984C11.9587 0.833984 15.1673 4.04261 15.1673 8.00065C15.1673 11.9587 11.9587 15.1673 8.00065 15.1673C4.04261 15.1673 0.833984 11.9587 0.833984 8.00065ZM8.00065 1.83398C4.5949 1.83398 1.83398 4.5949 1.83398 8.00065C1.83398 11.4064 4.5949 14.1673 8.00065 14.1673C11.4064 14.1673 14.1673 11.4064 14.1673 8.00065C14.1673 4.5949 11.4064 1.83398 8.00065 1.83398Z",
    fill: "#E12C2C"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2106_5359"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotificationIcon);
export default __webpack_public_path__ + "static/media/notificationIcon.4468ae2deff8146f475bcb155b8bbf35.svg";
export { ForwardRef as ReactComponent };